import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contentSource: "local",
  isEditing: false,
  content: "",
};

const manifestPreviewSlice = createSlice({
  name: "manifestPreview",
  initialState,
  reducers: {
    handleManifestPreview: (state, action) => {
      state.contentSource = action.payload.contentSource;
    },
  },
});

export const { handleManifestPreview } = manifestPreviewSlice.actions;
export default manifestPreviewSlice.reducer;
